export const shouldShowEventItem = (configuration, key) =>
  configuration.find(item => item.key === key).value
